import type { AnyObject } from '$util/types';

/**
 * Returns true only for plain objects and instances of classes.
 * Lodash `isObject()` is not this restrictive.
 */
export const isObjectType = (obj: unknown): obj is AnyObject =>
  Object.prototype.toString.call(obj) === '[object Object]';
